import { Controller } from '../common/Controller';
import { Helper } from '../common/helpers/Helper';
import { AppConfig } from '../AppConfig';

const vsprintf = require('sprintf-js').vsprintf

function getMobileDrawerMenuLabel(orgId, key) {
  let menuLabel = null
  const drawerMenuLabelsMobileCdpSettings = AppHelper.getSetting(orgId, 'DRAWER_MENU_LABELS_MOBILE')
  if(drawerMenuLabelsMobileCdpSettings) {
    const menuLabels = Controller.get().cdpHelper().parseCDPArrayOfObjectsString(drawerMenuLabelsMobileCdpSettings)
    if(Array.isArray(menuLabels) && menuLabels.length > 0) {
      const matchedItem = menuLabels.find(item => item && item.key === key)
      if (matchedItem && matchedItem.label) {
        menuLabel = matchedItem.label
      }
    }

  }
  return menuLabel
}

export class AppHelper {

  static getRouteWithDefaultFilter(orgId, basePath, settingKey) {
    if (window.location.pathname === basePath) {
      return `${window.location.pathname}${window.location.search || ''}`;
    }
    const defaultFilter = AppHelper.getSetting(orgId, settingKey);
    if (defaultFilter) {
      const separator = defaultFilter.startsWith('?') ? '' : '?';
      return `${basePath}${separator}${defaultFilter}`;
    }
    return basePath;
  }

  static getDrawerMenuItems() {
    return AppHelper.isDrawerMenuEnabled()
  }

  static getAdminDrawerMenuItems() {
    return ([
      [
        {
          route: Controller.get().getHomeByRole(),
          title: Helper.getString('orgs'),
          icon: 'dashboard',
          key: 'adminOrgs',
        },
        {
          route: Controller.get().getHomeByRole() + '/cbdefs-tags',
          title: Helper.getString('globalBlocksTags'),
          icon: 'space_dashboard',
          key: 'cbdefs-tags',
        },
        {
          route: Controller.get().getHomeByRole() + '/cbdefs',
          title: Helper.getString('globalBlocks'),
          icon: 'space_dashboard',
          key: 'cbdefs',
        },
        {
          route: Controller.get().getHomeByRole() + '/emailcbdefs',
          title: Helper.getString('emailglobalBlocks'),
          icon: 'space_dashboard',
          key: 'emailcbdefs',
        },
        {
          route: Controller.get().getHomeByRole() + '/emailpages',
          title: Helper.getString('emailpageslib'),
          icon: 'email',
          key: 'emailpages',
        },
      ],
      [
        {
          route: vsprintf('/admin/users'),
          title: Helper.getString('productusers'),
          icon: 'supervisor_account',
          key: 'usersOfOrg',
        }
      ]
    ])
  }

  static getOrgViewerDrawerMenuItems(orgId) {
    const viewerEnhanced = AppHelper.isViewerEnhanced(orgId)
    return ([
      [
        {
          key: 'orgDashboard',
          route: vsprintf('/admin/orgs/%s', [orgId]),
          title: Helper.getString('dashboard'),
          icon: 'dashboard'
        },
        {
          key: 'campaigns',
          title: Helper.getString('campaigns'),
          subItems: [
            ...(viewerEnhanced ? [{
              key: 'broadcasts',
              route: vsprintf('/admin/orgs/%s/campaigns/broadcasts', [orgId]),
              title: Helper.getString('broadcasts'),
            }] : []),
            {
              key: 'adsReportOrg',
              title: Helper.getString('adsReportOrg'),
              route: vsprintf('/admin/orgs/%s/campaigns/ads', [orgId]),
            }
          ]
        },
        ...(viewerEnhanced && AppHelper.isSettingEnabled(orgId, 'WHATSAPP_MENU') ? [{
          key: 'whatsapp',
          title: Helper.getString('whatsapp-menu'),
          subItems: [
            {
              key: 'whatsapp-templates',
              route: vsprintf('/admin/orgs/%s/whatsapp-templates', [orgId]),
              title: Helper.getString('whatsapp-templates'),
            },
            {
              key: 'whatsapp-broadcasts',
              route: vsprintf('/admin/orgs/%s/whatsapp-broadcasts', [orgId]),
              title: Helper.getString('broadcasts'),
            },
          ],
        }] : []),
        {
          key: 'crm',
          title: Helper.getString('crm'),
          subItems: [
            {
              key: 'crm-contacts',
              route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-contacts', [orgId]), 'CRM_CONTACT_DEFAULT_FILTER'),
              title: Helper.getString('crm-contacts'),
            },
            ...(AppHelper.isSubOrg(orgId) ? [] : [
              ...(AppHelper.isABMEnabled(orgId) ? [
                {
                  key: 'crm-accounts',
                  route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-accounts', [orgId]), 'CRM_ACCOUNT_DEFAULT_FILTER'),
                  title: Helper.getString('crm-accounts'),
                }
              ] : []),
            ]),
          ]
        },
      ],
      ...(viewerEnhanced ? [[
        {
          key: 'orgUsers',
          title: Helper.getString('admins'),
          subItems: [
            {
              key: 'usersOfOrg',
              route: vsprintf('/admin/orgs/%s/staff', [orgId]),
              title: Helper.getString('manage'),
              icon: 'supervisor_account',
            },
            ...(AppHelper.isStaffLoadEnabled(orgId) ? [{
              key: 'staff-assignments',
              route: vsprintf('/admin/orgs/%s/staff-assignments', [orgId]),
              title: Helper.getString('staff-assignments'),
            }] : []),
            ...(AppHelper.isStaffActivityTrackingEnabled(orgId) ? [{
              key: 'staff-activity',
              route: vsprintf('/admin/orgs/%s/staff-interactions', [orgId]),
              title: Helper.getString('staff-activity'),
            }] : []),
          ]
        },
        ...(AppHelper.isTeamsMenuEnabled(orgId) ? [{
          key: 'teams',
          route: vsprintf('/admin/orgs/%s/teams', [orgId]),
          title: Helper.getString('teams'),
          icon: 'people',
        }] : []),
      ]] : []),
    ])
  }

  static getOrgSUDrawerMenuItems(orgId) {
    return ([
      [
        {
          key: 'orgDashboard',
          route: vsprintf('/admin/orgs/%s', [orgId]),
          title: Helper.getString('dashboard'),
          icon: 'dashboard'
        },
        {
          key: 'settingsbranding',
          route: vsprintf('/admin/orgs/%s/branding', [orgId]),
          title: Helper.getString('settingsbranding'),
        },
        {
          key: 'assets',
          route: vsprintf('/admin/orgs/%s/assets', [orgId]),
          title: Helper.getString('assets'),
        },
        // {
        //   key: 'pages',
        //   route: vsprintf('/admin/orgs/%s/pages', [orgId]),
        //   title: Helper.getString('pages'),
        // },
        {
          key: 'site',
          title: Helper.getString('site'),
          subItems: [
            {
              key: 'pages',
              route: vsprintf('/admin/orgs/%s/pages', [orgId]),
              title: Helper.getString('pages'),
            },
            {
              key: 'cborgs',
              route: vsprintf('/admin/orgs/%s/cborgs', [orgId]),
              title: Helper.getString('blocks-widgets'),
            },
            {
              key: 'menus',
              route: vsprintf('/admin/orgs/%s/menus', [orgId]),
              title: Helper.getString('menus'),
            },
            {
              key: 'footernav',
              route: vsprintf('/admin/orgs/%s/footernavs', [orgId]),
              title: Helper.getString('footernav'),
            },
            {
              key: 'cotypes',
              route: vsprintf('/admin/orgs/%s/cos', [orgId]),
              title: Helper.getString('cotypes'),
            },
          ]
        },
        {
          key: 'blogSection',
          title: Helper.getString('blogs'),
          subItems: [
            {
              key: 'blogs',
              route: vsprintf('/admin/orgs/%s/blogs', [orgId]),
              title: Helper.getString('blogs'),
              icon: 'supervisor_account'
            },
            {
              key: 'blogTags',
              route: vsprintf('/admin/orgs/%s/btags', [orgId]),
              title: Helper.getString('tags'),
              icon: 'supervisor_account'
            },
            {
              key: 'blogLists',
              route: vsprintf('/admin/orgs/%s/blists', [orgId]),
              title: Helper.getString('lists'),
              icon: 'supervisor_account'
            },
          ]
        },
        // {
        //   key: 'nav',
        //   title: Helper.getString('nav'),
        //   subItems: [
        //     {
        //       key: 'menus',
        //       route: vsprintf('/admin/orgs/%s/menus', [orgId]),
        //       title: Helper.getString('menus'),
        //     },
        //     {
        //       key: 'footernav',
        //       route: vsprintf('/admin/orgs/%s/footernavs', [orgId]),
        //       title: Helper.getString('footernav'),
        //     },
        //   ]
        // },
        {
          key: 'campaigns',
          title: Helper.getString('campaigns'),
          subItems: [
            {
              key: 'broadcasts',
              route: vsprintf('/admin/orgs/%s/campaigns/broadcasts', [orgId]),
              title: Helper.getString('broadcasts'),
            },
            {
              key: 'crm-sequences',
              route: vsprintf('/admin/orgs/%s/campaigns/sequences', [orgId]),
              title: Helper.getString('crm-sequences'),
            },
            {
              key: 'adsReportOrg',
              title: Helper.getString('adsReportOrg'),
              route: vsprintf('/admin/orgs/%s/campaigns/ads', [orgId]),
            }
            /*{
              key: 'transactional',
              route: vsprintf('/admin/orgs/%s/campaigns/transactional', [orgId]),
              title: Helper.getString('transactional'),
            },*/
            /*{
              key: 'notifications',
              route: vsprintf('/admin/orgs/%s/campaigns/notifications', [orgId]),
              title: Helper.getString('notifications'),
            },*/
            /*{
              key: 'journeys',
              route: vsprintf('/admin/orgs/%s/journeys/messaging', [orgId]),
              title: Helper.getString('journeys'),
            },*/
            /*{
              key: 'popups',
              route: vsprintf('/admin/orgs/%s/campaigns/popups', [orgId]),
              title: Helper.getString('popups'),
            },*/
            /*{
              key: 'emailpages',
              route: vsprintf('/admin/orgs/%s/emailpages', [orgId]),
              title: Helper.getString('emailpages'),
            },*/
          ]
        },
        ...(AppHelper.isSettingEnabled(orgId, 'WHATSAPP_MENU') ? [
          {
            key: 'whatsapp',
            title: Helper.getString('whatsapp-menu'),
            subItems: [
              ...(AppHelper.isSettingEnabled(orgId, 'WHATSAPP_CHATBOTS') ? [{
                key: 'whatsapp-chatbots',
                route: vsprintf('/admin/orgs/%s/whatsapp-chatbots', [orgId]),
                title: Helper.getString('whatsapp-chatbots'),
              }] : []),
              {
                key: 'whatsapp-templates',
                route: vsprintf('/admin/orgs/%s/whatsapp-templates', [orgId]),
                title: Helper.getString('whatsapp-templates'),
              },
              {
                key: 'whatsapp-flows',
                route: vsprintf('/admin/orgs/%s/whatsapp-flows', [orgId]),
                title: Helper.getString('whatsapp-flows'),
              },
              {
                key: 'whatsapp-messages',
                route: vsprintf('/admin/orgs/%s/whatsapp-messages', [orgId]),
                title: Helper.getString('whatsapp-messages'),
              },
              {
                key: 'whatsapp-numbers',
                route: vsprintf('/admin/orgs/%s/whatsapp-numbers', [orgId]),
                title: Helper.getString('whatsapp-numbers'),
              }
            ],
          },
        ] : []),
        ...(AppHelper.isSettingEnabled(orgId, 'AUTOMATIONS_MENU') ? [
          {
            key: 'automations',
            route: vsprintf('/admin/orgs/%s/automations', [orgId]),
            title: Helper.getString('automations'),
          },
        ] : []),
        {
          key: 'crm',
          title: Helper.getString('crm'),
          subItems: [
            {
              key: 'crm-contacts',
              route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-contacts', [orgId]), 'CRM_CONTACT_DEFAULT_FILTER'),
              title: Helper.getString('crm-contacts'),
            },
            ...(AppHelper.isSubOrg(orgId) ? [] : [
              ...(AppHelper.isABMEnabled(orgId) ? [
                {
                  key: 'crm-accounts',
                  route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-accounts', [orgId]), 'CRM_ACCOUNT_DEFAULT_FILTER'),
                  title: Helper.getString('crm-accounts'),
                }
              ] : []),
              {
                key: 'segments',
                route: vsprintf('/admin/orgs/%s/segments', [orgId]),
                title: Helper.getString('segments'),
              },
              {
                key: 'crm-email-templates',
                route: vsprintf('/admin/orgs/%s/crm-email-templates', [orgId]),
                title: Helper.getString('crm-email-templates-short'),
              },
              {
                key: 'forms',
                route: vsprintf('/admin/orgs/%s/forms', [orgId]),
                title: Helper.getString('forms'),
              },
              {
                key: 'crm-inboxes',
                route: vsprintf('/admin/orgs/%s/crm-inboxes', [orgId]),
                title: Helper.getString('crm-inboxes'),
              },
              {
                key: 'crm-numbers',
                route: vsprintf('/admin/orgs/%s/crm-numbers', [orgId]),
                title: Helper.getString('numbers', 'Numbers'),
              },
              ...(AppHelper.isWorkflowsEnabled(orgId) ? [{
                key: 'workflows',
                route: vsprintf('/admin/orgs/%s/workflows', [orgId]),
                title: Helper.getString('workflows', 'Workflows'),
              }] : []),
              // {
              //   key: 'crm-user-settings',
              //   route: vsprintf('/admin/orgs/%s/crm-user-settings', [orgId]),
              //   title: Helper.getString('crm-user-settings'),
              // },
              {
                key: 'jobs',
                route: vsprintf('/admin/orgs/%s/jobscrm', [orgId]),
                title: Helper.getString('jobs'),
              },
            ]),
            /*...(!AppHelper.isSettingEnabled(orgId,'CRM_MENU_ONEVIEW') ? [] : [{
              key: 'oneview',
              route: vsprintf('/admin/orgs/%s/oneview', [orgId]),
              title: Helper.getString('oneview'),
            }]),*/
          ]
        },
        ...(AppHelper.isSettingEnabled(orgId, 'USAGE_WALLET_MENU') ? [
          {
            key: 'usage-wallet',
            route: vsprintf('/admin/orgs/%s/usage-wallet', [orgId]),
            title: Helper.getString('usage-wallet'),
          },
        ] : []),
        {
          key: 'catalogSection',
          title: Helper.getString('ecom'),
          subItems: [
            {
              key: 'products',
              route: vsprintf('/admin/orgs/%s/products', [orgId]),
              title: Helper.getString('products'),
              icon: 'layers'
            },
            {
              key: 'catsL1',
              route: vsprintf('/admin/orgs/%s/cats', [orgId]),
              title: Helper.getString('cats'),
              icon: 'category'
            },
            {
              key: 'brands',
              route: vsprintf('/admin/orgs/%s/brands', [orgId]),
              title: Helper.getString('brands'),
              icon: 'loyalty'
            },
            // {
            //   key: 'banners',
            //   route: vsprintf('/admin/orgs/%s/banners', [orgId]),
            //   title: Helper.getString('banners'),
            //   icon: 'view_carousel',
            // },
            {
              key: 'prodLists',
              route: vsprintf('/admin/orgs/%s/lists', [orgId]),
              title: Helper.getString('lists'),
              icon: 'collections_bookmark'
            },
            {
              key: 'orders',
              route: vsprintf('/admin/orgs/%s/orders', [orgId]),
              title: Helper.getString('orders'),
              icon: 'local_mall'
            },
            {
              key: 'coupons',
              route: vsprintf('/admin/orgs/%s/coupons', [orgId]),
              title: Helper.getString('coupons'),
              icon: 'local_offer'
            },
            // {
            //   key: 'testimonials',
            //   route: vsprintf('/admin/orgs/%s/testimonials', [orgId]),
            //   title: Helper.getString('testimonials'),
            //   icon: 'supervisor_account'
            // },
            // {
            //   key: 'benefits',
            //   route: vsprintf('/admin/orgs/%s/benefits', [orgId]),
            //   title: Helper.getString('benefits'),
            //   icon: 'supervisor_account'
            // },
            // {
            //   key: 'faqs',
            //   route: vsprintf('/admin/orgs/%s/faqs', [orgId]),
            //   title: Helper.getString('faqs'),
            //   icon: 'supervisor_account',
            // },
            // {
            //   key: 'faqSections',
            //   route: vsprintf('/admin/orgs/%s/faqsections', [orgId]),
            //   title: Helper.getString('faqsections'),
            //   icon: 'supervisor_account'
            // }
          ]
        },
        AppHelper.getContentDrawerObject(orgId),
      ],
      [
        {
          key: 'orgUsers',
          title: Helper.getString('admins'),
          subItems: [
            {
              key: 'usersOfOrg',
              route: vsprintf('/admin/orgs/%s/staff', [orgId]),
              title: Helper.getString('manage'),
              icon: 'supervisor_account',
            },
            ...(AppHelper.isStaffLoadEnabled(orgId) ? [
              {
                key: 'staff-assignments',
                route: vsprintf('/admin/orgs/%s/staff-assignments', [orgId]),
                title: Helper.getString('staff-assignments'),
              }
            ] : []),
            ...(AppHelper.isStaffActivityTrackingEnabled(orgId) ? [
              {
                key: 'staff-activity',
                route: vsprintf('/admin/orgs/%s/staff-interactions', [orgId]),
                title: Helper.getString('staff-activity'),
              }
            ] : []),
          ]
        },
        ...(AppHelper.isTeamsMenuEnabled(orgId) ? [{
          key: 'teams',
          route: vsprintf('/admin/orgs/%s/teams', [orgId]),
          title: Helper.getString('teams'),
          icon: 'people',
        }] : []),
        {
          key: 'settings',
          route: vsprintf('/admin/orgs/%s/settings', [orgId]),
          title: Helper.getString('settings'),
          icon: 'supervisor_account'
        },
      ]
    ])
  }

  static getOrgBloggerDrawerMenuItems(orgId) {
    return (
      [
        // {
        //   key: 'content',
        //   title: Helper.getString('ai-content'),
        //   subItems: [
        //     {
        //       key: 'content-personas',
        //       route: vsprintf('/admin/orgs/%s/content/personas', [orgId]),
        //       title: Helper.getString('content-personas-short'),
        //       icon: 'supervisor_account'
        //     },
        //     {
        //       key: 'content-generator',
        //       route: vsprintf('/admin/orgs/%s/content/generator', [orgId]),
        //       title: Helper.getString('content-blog-generator'),
        //       icon: 'supervisor_account'
        //     },
        //   ],
        // },
        {
          key: 'blogs',
          route: vsprintf('/admin/orgs/%s/blogs', [orgId]),
          title: Helper.getString('blogs'),
          icon: 'supervisor_account'
        },
        AppHelper.getContentDrawerObject(orgId),
      ]
    )
  }

  static getOrgCRMDrawerMenuItems(orgId) {
    return (
      [
        {
          key: 'crm',
          title: Helper.getString('crm'),
          subItems: [
            {
              key: 'crm-contacts',
              route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-contacts', [orgId]), 'CRM_CONTACT_DEFAULT_FILTER'),
              title: Helper.getString('crm-contacts'),
            },
            ...(AppHelper.isSubOrg(orgId) ? [] : [
              ...(AppHelper.isABMEnabled(orgId) ? [
                {
                  key: 'crm-accounts',
                  route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-accounts', [orgId]), 'CRM_ACCOUNT_DEFAULT_FILTER'),
                  title: Helper.getString('crm-accounts'),
                }
              ] : []),
              {
                key: 'crm-sequences',
                route: vsprintf('/admin/orgs/%s/campaigns/sequences', [orgId]),
                title: Helper.getString('crm-sequences'),
              },
              {
                key: 'crm-inboxes',
                route: vsprintf('/admin/orgs/%s/crm-inboxes', [orgId]),
                title: Helper.getString('crm-inboxes'),
              },
              {
                key: 'crm-email-templates',
                route: vsprintf('/admin/orgs/%s/crm-email-templates', [orgId]),
                title: Helper.getString('crm-email-templates-short'),
              },
              // {
              //   key: 'crm-user-settings',
              //   route: vsprintf('/admin/orgs/%s/crm-user-settings', [orgId]),
              //   title: Helper.getString('crm-user-settings'),
              // },
              // {
              //   key: 'forms',
              //   route: vsprintf('/admin/orgs/%s/forms', [orgId]),
              //   title: Helper.getString('forms'),
              // },
            ]),
            {
              key: 'jobs',
              route: vsprintf('/admin/orgs/%s/jobscrm', [orgId]),
              title: Helper.getString('jobs'),
            },
            /*...(!AppHelper.isSettingEnabled(orgId,'CRM_MENU_ONEVIEW') ? [] : [{
              key: 'oneview',
              route: vsprintf('/admin/orgs/%s/oneview', [orgId]),
              title: Helper.getString('oneview'),
            }]),*/
          ]
        },
      ]
    )
  }

  static isDrawerMenuEnabled() {
    const orgUnitId = Controller.get().roleHelper().getOrgUnitId()
    const {orgId} = AppHelper.parseOrgUnitId(orgUnitId)
    const pName = window.location.pathname
    let menu = []
    if (pName.startsWith('/admin/orgs/')) {
      if (pName.endsWith('/preview')) {
        return null
      }
      if (Controller.get().userMgr().isProductSU()) {
        menu = AppHelper.getOrgSUDrawerMenuItems(orgId)
      } else if (AppConfig.ORGSU_ACCESS_ALLOWED && (Controller.get().userMgr().hasOrgRole(orgUnitId, 'SUPERUSER'))) {
        menu = AppHelper.getOrgSUDrawerMenuItems(orgId)
      } else if (Controller.get().userMgr().hasOrgRole(orgUnitId, 'VIEWER')) {
        menu = AppHelper.getOrgViewerDrawerMenuItems(orgId)
      } else {
        const submenu = []
        if (Controller.get().userMgr().hasOrgRole(orgUnitId, 'BLOGGER')) {
          submenu.push(...AppHelper.getOrgBloggerDrawerMenuItems(orgId))
        }
        if (Controller.get().userMgr().hasOrgRole(orgUnitId, 'CRM')) {
          submenu.push(...AppHelper.getOrgCRMDrawerMenuItems(orgId))
        }
        if (submenu.length > 0) { menu.push(submenu) }
      }
    } else if (pName.startsWith('/admin')) {
      if (Controller.get().userMgr().isProductSU()) {
        menu = AppHelper.getAdminDrawerMenuItems()
      }
    }
    if (AppConfig.ADMIN_DRAWER_MENU_ENABLED && menu.length > 0) {
      return menu
    }
    return null
  }

  static getPublicDrawerMenuItems() {
    return []
  }

  static getMobileDrawerMenuItems() {
    const orgUnitId = Controller.get().roleHelper().getOrgUnitId()
    const {orgId} = AppHelper.parseOrgUnitId(orgUnitId)
    const pName = window.location.pathname
    let menu = []
    if (pName.startsWith('/admin/orgs/')) {
      if (pName.endsWith('/preview')) {
        return null
      }
      if (Controller.get().userMgr().isProductSU()) {
        menu = AppHelper.getOrgSUDrawerMenuItemsForMobile(orgId)
      } else if (AppConfig.ORGSU_ACCESS_ALLOWED && (Controller.get().userMgr().hasOrgRole(orgUnitId, 'SUPERUSER') || Controller.get().userMgr().hasOrgRole(orgUnitId, 'VIEWER'))) {
        menu = AppHelper.getOrgSUDrawerMenuItemsForMobile(orgId)
      } else if (Controller.get().userMgr().hasOrgRole(orgUnitId, 'VIEWER')) {
        menu = AppHelper.getOrgViewerDrawerMenuItemsForMobile(orgId)
      } else {
        if (Controller.get().userMgr().hasOrgRole(orgUnitId, 'BLOGGER')) {
          // not pushing anything in mobile view
          menu = AppHelper.getOrgBloggerDrawerMenuItemsForMobile(orgId)
        }
        if (Controller.get().userMgr().hasOrgRole(orgUnitId, 'CRM')) {
          // not pushing anything in mobile view
          menu = AppHelper.getOrgCRMDrawerMenuItemsForMobile(orgId)
        }
      }
    } else if (pName.startsWith('/admin')) {
      if (Controller.get().userMgr().isProductSU()) {
        menu = AppHelper.getAdminDrawerMenuItemsForMobile()
      }
    }
    if (AppConfig.ADMIN_DRAWER_MENU_ENABLED && menu.length > 0) {
      return menu
    }
    return null
  }

  static getAdminDrawerMenuItemsForMobile() {
    return ([
      {
        route: Controller.get().getHomeByRole(),
        title: Helper.getString('orgs'),
        icon: 'business',
        key: 'adminOrgs',
      },
      {
        route: vsprintf('/admin/users'),
        title: Helper.getString('productusers'),
        icon: 'supervisor_account',
        key: 'usersOfOrg',
      }
    ])
  }

  static getOrgCRMDrawerMenuItemsForMobile(orgId) {
    return (
      [
        {
          key: 'crm-contacts',
          route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-contacts', [orgId]), 'CRM_CONTACT_DEFAULT_FILTER'),
          title: getMobileDrawerMenuLabel(orgId, 'crm-contacts') || Helper.getString('leads'),
          icon: 'assignment_ind'
        },
        ...(AppHelper.isSubOrg(orgId) ? [] : [
          ...(AppHelper.isABMEnabled(orgId) ? [
            {
              key: 'crm-accounts',
              route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-accounts', [orgId]), 'CRM_ACCOUNT_DEFAULT_FILTER'),
              title: getMobileDrawerMenuLabel(orgId, 'crm-accounts') || Helper.getString('accounts'),
              icon: 'business'
            }
          ] : []),
        ]),
        ...(!AppHelper.isSettingEnabled(orgId,'CRM_MENU_ONEVIEW') ? [] : [{
          key: 'oneview',
          route: vsprintf('/admin/orgs/%s/oneview', [orgId]),
          title: getMobileDrawerMenuLabel(orgId, 'oneview') || Helper.getString('oneview'),
          icon: 'data_exploration'
        }]),
        {
          key: 'more',
          route: vsprintf('/admin/orgs/%s/staff', [orgId]),
          title: Helper.getString('menu'),
          icon: 'menu'
        }
      ]
    )
  }

  static getOrgBloggerDrawerMenuItemsForMobile(orgId) {
    return (
      [
        {
          key: 'more',
          route: vsprintf('/admin/orgs/%s/staff', [orgId]),
          title: Helper.getString('menu'),
          icon: 'menu'
        }
      ]
    )
  }

  static getOrgViewerDrawerMenuItemsForMobile(orgId) {
    return (
      [
        {
          key: 'crm-contacts',
          route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-contacts', [orgId]), 'CRM_CONTACT_DEFAULT_FILTER'),
          title:  getMobileDrawerMenuLabel(orgId, 'crm-contacts') || Helper.getString('leads'),
          icon: 'assignment_ind'
        },
        ...(AppHelper.isSubOrg(orgId) ? [] : [
          ...(AppHelper.isABMEnabled(orgId) ? [
            {
              key: 'crm-accounts',
              route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-accounts', [orgId]), 'CRM_ACCOUNT_DEFAULT_FILTER'),
              title: getMobileDrawerMenuLabel(orgId, 'crm-accounts') || Helper.getString('accounts'),
              icon: 'business'
            }
          ] : []),
        ]),
        {
          key: 'adsReportOrg',
          route: vsprintf('/admin/orgs/%s/campaigns/ads', [orgId]),
          title: getMobileDrawerMenuLabel(orgId, 'adsReportOrg') || Helper.getString('adsReportOrg'),
          icon: 'analytics'
        },
        {
          key: 'orgDashboard',
          route: vsprintf('/admin/orgs/%s', [orgId]),
          title: getMobileDrawerMenuLabel(orgId, 'orgDashboard') || Helper.getString('visitors'),
          icon: 'insights'
        },
        {
          key: 'more',
          route: vsprintf('/admin/orgs/%s/staff', [orgId]),
          title: Helper.getString('menu'),
          icon: 'menu'
        }
      ]
    )
  }

  static getOrgSUDrawerMenuItemsForMobile(orgId) {
    const addReloadAppBtn = AppHelper.isSettingEnabled(orgId, 'RELOAD_APP')
    return (
      [
        {
          key: 'crm-contacts',
          route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-contacts', [orgId]), 'CRM_CONTACT_DEFAULT_FILTER'),
          title:  getMobileDrawerMenuLabel(orgId, 'crm-contacts') || Helper.getString('leads'),
          icon: 'assignment_ind'
        },
        ...(AppHelper.isSubOrg(orgId) ? [] : [
          ...(AppHelper.isABMEnabled(orgId) ? [
            {
              key: 'crm-accounts',
              route: AppHelper.getRouteWithDefaultFilter(orgId, vsprintf('/admin/orgs/%s/crm-accounts', [orgId]), 'CRM_ACCOUNT_DEFAULT_FILTER'),
              title: getMobileDrawerMenuLabel(orgId, 'crm-accounts') || Helper.getString('accounts'),
              icon: 'business'
            }
          ] : []),
        ]),
        {
          key: 'adsReportOrg',
          route: vsprintf('/admin/orgs/%s/campaigns/ads', [orgId]),
          title: getMobileDrawerMenuLabel(orgId, 'adsReportOrg') || Helper.getString('adsReportOrg'),
          icon: 'analytics'
        },
        {
          key: 'orgDashboard',
          route: vsprintf('/admin/orgs/%s', [orgId]),
          title: getMobileDrawerMenuLabel(orgId, 'orgDashboard') || Helper.getString('visitors'),
          icon: 'insights'
        },
        // {
        //   key: 'reports',
        //   route: vsprintf('/admin/orgs/%s/reports', [orgId]),
        //   title: Helper.getString('campaigns'),
        //   icon: 'campaign'
        // },
        ...(!AppHelper.isSettingEnabled(orgId,'CRM_MENU_ONEVIEW') ? [] : [{
          key: 'oneview',
          route: vsprintf('/admin/orgs/%s/oneview', [orgId]),
          title: getMobileDrawerMenuLabel(orgId, 'oneview') || Helper.getString('oneview'),
          icon: 'data_exploration'
        }]),
        ...(addReloadAppBtn ? [{
          key: 'reloadapp',
          title: getMobileDrawerMenuLabel(orgId, 'reloadapp') || 'Reload',
          icon: 'replay'
        }] : []),
        {
          key: 'more',
          route: vsprintf('/admin/orgs/%s/staff', [orgId]),
          title: Helper.getString('menu'),
          icon: 'menu'
        }
      ]
    )
  }


  static getContentDrawerObject(orgId) {
    return {
      key: 'content',
      title: Helper.getString('ai-content'),
      subItems: [
        {
          key: 'content-personas',
          route: vsprintf('/admin/orgs/%s/content/personas', [orgId]),
          title: Helper.getString('content-personas-short'),
          icon: 'supervisor_account'
        },
        {
          key: 'content-planner',
          route: vsprintf('/admin/orgs/%s/content/planner', [orgId]),
          title: Helper.getString('content-planner'),
          icon: 'supervisor_account'
        },
        {
          key: 'content-generator',
          route: vsprintf('/admin/orgs/%s/content/generator', [orgId]),
          title: Helper.getString('content-blog-generator'),
          icon: 'supervisor_account'
        },
      ],
    }
  }
  static parseOrgId(pathname) {
    if(pathname) {
      const pathSpilt = pathname.split('/')
      // console.log(pathSpilt,'PATH_SPLIT');
      if(pathname && pathname.length > 2 && pathSpilt[1] === 'admin' && pathSpilt[2] === 'orgs') {
        return pathSpilt[3]
      }
    }
  }

  static modifyCbSiteData(cbSiteList, cbGlobalList,cbTenantList) {

    const orgId = this.parseOrgId(window.location.pathname)
    const widgetsTagsData = {}

    cbGlobalList.items.forEach(widDef=>{
      if(!widgetsTagsData[widDef.id]) widgetsTagsData[widDef.id] = {}
      if(widDef.tags) {
        widgetsTagsData[widDef.id].tags = widDef.tags
      }
      if(widDef.state) {
        widgetsTagsData[widDef.id].state = widDef.state
      }
      if(widDef.cbstyle) {
        widgetsTagsData[widDef.id].cbstyle = widDef.cbstyle
      }
      if(widDef.image) {
        widgetsTagsData[widDef.id].image = widDef.image
      }
      if(widDef.id) {
        widgetsTagsData[widDef.id].id = widDef.id
      }
      if(widDef.singleton) {
        widgetsTagsData[widDef.id].singleton = widDef.singleton
      }
    })

    for (const widgetId in cbTenantList) {
      const widget = cbTenantList[widgetId]
      if(!widgetsTagsData[widgetId]) widgetsTagsData[widgetId] = {}
      if(widget.id) {
        widgetsTagsData[widgetId].id = widget.id
      }
      if(widget.singleton) {
        widgetsTagsData[widgetId].singleton = widget.singleton
      }
    }

    cbSiteList.map(widDef=>{
      if(!widDef.tags && widgetsTagsData[widDef.cbGlobalId] && widgetsTagsData[widDef.cbGlobalId].tags) {
        widDef.tags = widgetsTagsData[widDef.cbGlobalId].tags
      }
      if(!widDef.state && widgetsTagsData[widDef.cbGlobalId] && widgetsTagsData[widDef.cbGlobalId].state) {
        widDef.state = widgetsTagsData[widDef.cbGlobalId].state
      }
      if(!widDef.cbstyle && widgetsTagsData[widDef.cbGlobalId] && widgetsTagsData[widDef.cbGlobalId].cbstyle) {
        widDef.cbstyle = widgetsTagsData[widDef.cbGlobalId].cbstyle
      }
      if(!widDef.image && widgetsTagsData[widDef.cbGlobalId] && widgetsTagsData[widDef.cbGlobalId].image) {
        widDef.image = widgetsTagsData[widDef.cbGlobalId].image
      }

      if(!widDef.reusableTraverseId &&
        widgetsTagsData[widDef.cbGlobalId || widDef.cbTenantId] &&
        widgetsTagsData[widDef.cbGlobalId || widDef.cbTenantId].id) {
        const options = {
          orgId,
          widgetId: widDef.id,
          widgetGlobalId: widgetsTagsData[widDef.cbGlobalId || widDef.cbTenantId].id,
        };
        widDef.reusableTraverseId =  this.resuableWidgetScopeLink(options)
      }

      if(!widDef.singleton &&
        widgetsTagsData[widDef.cbGlobalId || widDef.cbTenantId] &&
        widgetsTagsData[widDef.cbGlobalId || widDef.cbTenantId].singleton) {
        widDef.singleton = widgetsTagsData[widDef.cbGlobalId || widDef.cbTenantId].singleton
      }

      return widDef
    })

    return cbSiteList
  }

  static resuableWidgetScopeLink(options) {
    const orgId = options.orgId || ''
    const widgetId = options.widgetId || ''
    const widgetGlobalId = options.widgetGlobalId || ''

    return 'o' + orgId + '-' + widgetId + '-' + widgetGlobalId
  }

  static preFillWidgetDefaultValues (formDef, cbDef) {//currently done only for subType 'color'
    for (const step of formDef.steps) {
      for (const field of step.fields) {
        if(cbDef.fields[field.key] && cbDef.fields[field.key].defaultVal && field.subType === 'colour') {
          field.defaultValue = cbDef.fields[field.key].defaultVal
        }
      }
    }

    return formDef
  }

  static pageCbId(id) {
    return `#page-cb-${id}`
  }

  static infoTextHelper(data) {
    try {
      // Its a valid json
      const parsedData = JSON.parse(data)
      if(!parsedData.__azformatted)return ''

      let renderText = ''
      parsedData.__azformatted.blocks && parsedData.__azformatted.blocks.forEach(block=>{
        if(block.text) {
          renderText += block.text + ' '
        }
      })
      return renderText.trim()
    } catch (err) {
      // its a plain stiring
      return data || '[Not set]'
    }
  }

  static widgetStatus(items, options) {
    const allItems = options.cbGlobal || {}
    const tenantItems = options.cbOrg || {}
    const widStatus = {}
    if(allItems.items) {
      allItems.items.forEach(item => {
        if(!widStatus[item.id]) {
          widStatus[item.id] = item.state
        }
      });
    }
    if(tenantItems.items) {
      tenantItems.items.forEach(item => {
        if(!widStatus[item.id]) {
          widStatus[item.id] = item.state
        }
      });
    }
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      const id = item.cbGlobalId || item.cbTenantId
      if(item.id && widStatus[id] && widStatus[id] === 'DISABLED') {
        items.splice(index,1)
      }
    }
  }

  static getWidgetPageId(widgetId, pageBlocks) {
    for (const widget in pageBlocks) {
      const widData = pageBlocks[widget];
      if(widget === widgetId || widData.cbSiteBlockId === widgetId) {
        return widData.id
      }
    }
    return ''
  }

  static generateNewOrder(items) {
    let largest = 0
    let newOrder = 10
    if(items) {
      const orderNumbers = items.map(item => Number(item.order)).filter(order => !Number.isNaN(order));
      if(orderNumbers.length > 0) {
        largest = Math.max(...orderNumbers)
        if(largest > 0 ) {
          newOrder = (Math.floor(largest / 10) * 10) + 10
        }
      }
    }
    newOrder = newOrder.toString().padStart(3, '0')
    return newOrder
  }

  static isSubOrg(orgId) {
    return !!Controller.get().userMgr().getSubOrgId(orgId)
  }

  static isCdpSettingEnabled(orgId, settingName, defaultVal = false, responsive = false, doUserOrTeamCheck = true) {
    const settingVal = AppHelper.getCdpSetting(orgId, settingName, '', responsive, doUserOrTeamCheck)
    if (!settingVal) { return defaultVal }
    const settingRoles = settingVal.split(',').filter(a => !!a).map(a => a.trim())
    if (settingRoles.length === 1) {
      if (['enabled', 'show'].includes(settingRoles[0])) { return true }
      if (['disabled', 'hide'].includes(settingRoles[0])) { return false }
    }
    return (Controller.get().userMgr().isProductSU() && settingRoles.includes('PRODUCTSU')) ||
      settingRoles.some(role => Controller.get().roleHelper().hasCurrentOrgRole(role) || (role === 'SLIXTA' && Controller.get().userMgr().isSlixtaStaff()))
  }
  static getCdpSetting(orgId, settingName, defaultVal = '', responsive = false, doUserOrTeamCheck = true, configOverrides = null) {
    let settingVal
    const subOrgId = Controller.get().userMgr().getSubOrgId(orgId)
    const userId = Controller.get().userMgr().getUserId()
    let isTeamLogin = false
    if ((doUserOrTeamCheck || responsive) && settingName !== 'MULTI_LOCATION') {
      isTeamLogin = AppHelper.isTeamLogin(orgId)
    }
    if (responsive) {
      if (Helper.isMobileView()) {
        if (doUserOrTeamCheck) {
          settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + `_MOBILE:${userId}`, orgId)
          if(isTeamLogin) {
            if (subOrgId) {
              settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + `_MOBILE:${subOrgId}`, orgId)
            }
            settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + '_MOBILE:TEAM', orgId)
          }
        }
        settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + '_MOBILE', orgId)
      } else {
        if (doUserOrTeamCheck) {
          settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + `_DESKTOP:${userId}`, orgId)
          if(isTeamLogin) {
            if (subOrgId) {
              settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + `_DESKTOP:${subOrgId}`, orgId)
            }
            settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + '_DESKTOP:TEAM', orgId)
          }
        }
        settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + '_DESKTOP', orgId)
      }
    }
    if (doUserOrTeamCheck) {
      settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + `:${userId}`, orgId)
      if (isTeamLogin) {
        if (subOrgId) {
          settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + `:${subOrgId}`, orgId)
        }
        settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName + ':TEAM', orgId)
      }
    }
    if (!settingVal && configOverrides) {
      settingVal = AppHelper.getConfigLevelOverride(orgId, configOverrides)
    }
    settingVal = settingVal || Controller.get().cdpHelper().getSetting(settingName, orgId)

    if (!settingVal) { return defaultVal }
    return settingVal
  }
  static getConfigLevelOverride(orgId, overrides) {
    if (!overrides || typeof overrides !== 'object') { return '' }
    let settingVal
    if (overrides.platform && typeof overrides.platform === 'object') {
      if (Helper.isMobileView()) {
        if (overrides.platform.mobile != null) {
          settingVal = overrides.platform.mobile
        } else if (overrides.platform.MOBILE != null) {
          settingVal = overrides.platform.MOBILE
        }
      } else if (overrides.platform.desktop != null) {
        settingVal = overrides.platform.desktop
      } else if (overrides.platform.DESKTOP != null) {
        settingVal = overrides.platform.DESKTOP
      }
    }
    const userId = Controller.get().userMgr().getUserId()
    const subOrgId = Controller.get().userMgr().getSubOrgId(orgId)
    if (!settingVal && overrides.user && typeof overrides.user === 'object' && userId && overrides.user[userId] != null) {
      settingVal = overrides.user[userId]
    }
    if (!settingVal && overrides.team && typeof overrides.team === 'object' && subOrgId && overrides.team[subOrgId] != null) {
      settingVal = overrides.team[subOrgId]
    }
    return settingVal || ''
  }
  static getSettingLookupArgs(settingDef) {
    const levels = Array.isArray(settingDef.levels) ? settingDef.levels : []
    const overrides = settingDef.defaultValueOverrides && typeof settingDef.defaultValueOverrides === 'object'
      ? settingDef.defaultValueOverrides : null
    return {
      defaultVal: settingDef.defaultValue !== undefined && settingDef.defaultValue !== null ? settingDef.defaultValue : '',
      responsive: levels.includes('platform') || !!(overrides && overrides.platform),
      doUserOrTeamCheck: levels.includes('user') || levels.includes('team') || !!(overrides && (overrides.user || overrides.team)),
      configOverrides: overrides
    }
  }
  static getSetting(orgId, settingName) {
    const settingDef = Controller.get().cdpHelper().getSettingDef(orgId, settingName)
    if (!settingDef) {
      return AppHelper.getCdpSetting(orgId, settingName)
    }
    const { defaultVal, responsive, doUserOrTeamCheck, configOverrides } = AppHelper.getSettingLookupArgs(settingDef)
    return AppHelper.getCdpSetting(orgId, settingName, defaultVal, responsive, doUserOrTeamCheck, configOverrides)
  }
  static isSettingEnabled(orgId, settingName) {
    const settingDef = Controller.get().cdpHelper().getSettingDef(orgId, settingName)
    if (!settingDef) {
      return AppHelper.isCdpSettingEnabled(orgId, settingName)
    }
    const { defaultVal, responsive, doUserOrTeamCheck, configOverrides } = AppHelper.getSettingLookupArgs(settingDef)
    const settingVal = AppHelper.getCdpSetting(orgId, settingName, defaultVal, responsive, doUserOrTeamCheck, configOverrides)
    if (!settingVal) { return false }
    const settingRoles = settingVal.split(',').filter(a => !!a).map(a => a.trim())
    if (settingRoles.length === 1) {
      if (['enabled', 'show'].includes(settingRoles[0])) { return true }
      if (['disabled', 'hide'].includes(settingRoles[0])) { return false }
    }
    return (Controller.get().userMgr().isProductSU() && settingRoles.includes('PRODUCTSU')) ||
      settingRoles.some(role => Controller.get().roleHelper().hasCurrentOrgRole(role) || (role === 'SLIXTA' && Controller.get().userMgr().isSlixtaStaff()))
  }
  static getAllCdpSettings(orgId) {
    return Controller.get().cdpHelper().getAllSettings(orgId)
  }
  static getCdpSettingOverrides(orgId, baseKey, teams = [], users = []) {
    const allSettings = AppHelper.getAllCdpSettings(orgId);
    const overrides = [];

    for (const platform of ['MOBILE', 'DESKTOP']) {
      const key = `${baseKey}_${platform}`;

      if (key in allSettings) {
        overrides.push({
          level: 'platform',
          target: platform,
          value: allSettings[key]
        });
      }
    }

    for (const teamId of teams) {
      const key = `${baseKey}:${teamId}`;

      if (key in allSettings) {
        overrides.push({
          level: 'team',
          target: teamId,
          value: allSettings[key]
        });
      }
    }

    for (const userId of users) {
      const key = `${baseKey}:${userId}`;

      if (key in allSettings) {
        overrides.push({
          level: 'user',
          target: userId,
          value: allSettings[key]
        });
      }
    }

    return overrides;
  }

  static isABMEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'CRM_ABM')
  }
  static isTeamsEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'MULTI_LOCATION')
  }
  static isDialogScrollbarEnabled() {
    return AppHelper.isSettingEnabled(Controller.get().roleHelper().getOrgId(), 'DIALOG_SCROLLBAR')
  }
  static isTeamsMenuEnabled(orgId) {
    if (!orgId) { return false }
    return AppHelper.isSettingEnabled(orgId, 'TEAMS_MENU')
  }
  static isWorkflowsEnabled(orgId) {
    if (!orgId) { return false }
    return AppHelper.isSettingEnabled(orgId, 'WORKFLOWS_MENU') || AppHelper.isSettingEnabled(orgId, 'CRM_MENU_WORKFLOWS')
  }
  static isTeamLogin(orgId) {
    const subOrgId = Controller.get().userMgr().getSubOrgId(orgId)
    return !!(AppHelper.isTeamsEnabled(orgId) && subOrgId)
  }
  static hasOnlyTeamAccess(orgId) {
    if (!orgId) { return false }
    const appUser = Controller.get().userMgr().getAppUser()
    const orgs = (appUser && Array.isArray(appUser.orgs)) ? appUser.orgs : []
    const tenantOrgs = orgs.filter(org => org && org.orgId === orgId)
    return tenantOrgs.length > 0 && tenantOrgs.every(org => !!org.subOrgId)
  }
  static getAccessibleTeamIds(orgId) {
    return AppHelper.getAccessibleTeams(orgId).map(team => team.id)
  }
  static getAccessibleTeams(orgId) {
    if (!orgId) { return [] }
    const appUser = Controller.get().userMgr().getAppUser()
    const orgs = (appUser && Array.isArray(appUser.orgs)) ? appUser.orgs : []
    return orgs.filter(org => org && org.orgId === orgId && org.subOrgId).map(org => ({
      id: org.subOrgId,
      title: org.title,
    }))
  }
  static isTeamsUnifiedView(orgId) {
    if (!orgId) { return false }
    const appUser = Controller.get().userMgr().getAppUser()
    const orgs = (appUser && Array.isArray(appUser.orgs)) ? appUser.orgs : []
    return orgs.some(org => org && org.orgId === orgId && org.unifiedTeam === true)
  }
  /** Query subOrgId sentinel; RBAC expands to the user’s accessible teams (TEAMS_UNIFIED_VIEW). */
  static get CURRENT_TEAMS_SUB_ORG_ID() {
    return 'current-teams'
  }
  static getTeamApiParams(orgId, staffKey) {
    if (AppHelper.isTeamsUnifiedView(orgId)) {
      return { subOrgId: AppHelper.CURRENT_TEAMS_SUB_ORG_ID }
    }
    const subOrgId = Controller.get().userMgr().getSubOrgId(orgId)
    if (staffKey) {
      return { [staffKey]: subOrgId }
    }
    return subOrgId ? { subOrgId } : {}
  }
  static getTeamBodyParams(orgId, staffKey) {
    if (AppHelper.isTeamsUnifiedView(orgId)) {
      return {}
    }
    return AppHelper.getTeamApiParams(orgId, staffKey)
  }
  static getOrgSwitcherOrgs(orgs, selectedOrgUnitId) {
    if (!Array.isArray(orgs) || orgs.length === 0) {
      return []
    }
    const result = []
    const collapsedTenants = new Set()
    orgs.forEach((org) => {
      if (!org || !org.orgId) {
        return
      }
      if (org.subOrgId && AppHelper.isTeamsUnifiedView(org.orgId)) {
        if (collapsedTenants.has(org.orgId)) {
          return
        }
        collapsedTenants.add(org.orgId)
        const selected = orgs.find(item => item && item.orgId === org.orgId && item.subOrgId && item.subOrgId === selectedOrgUnitId)
        const representative = selected || org
        result.push({
          ...representative,
          title: Controller.get().roleHelper().getMainOrgTitle(org.orgId) || representative.title,
        })
        return
      }
      result.push(org)
    })
    return result
  }
  static shouldShowOrgSwitcher() {
    if (Controller.get().userMgr().isProductSU()) {
      return false
    }
    const appUser = Controller.get().userMgr().getAppUser()
    const orgs = (appUser && Array.isArray(appUser.orgs)) ? appUser.orgs : []
    const selectedOrgUnitId = Controller.get().roleHelper().getOrgUnitId()
    return AppHelper.getOrgSwitcherOrgs(orgs, selectedOrgUnitId).length > 1
  }
  static isRestrictViewToAssignedContacts(orgId) {
    if (Controller.get().userMgr().isProductSU() || (Controller.get().userMgr().hasOrgRole(orgId, 'SUPERUSER') || Controller.get().userMgr().hasOrgRole(orgId, 'VIEWER'))) { return false }
    return AppHelper.isSettingEnabled(orgId, 'CRM_RESTRICT_VIEW_ASSIGNED_CONTACTS')
  }
  static isRestrictViewToAssignedAccounts(orgId) {
    if (Controller.get().userMgr().isProductSU() || (Controller.get().userMgr().hasOrgRole(orgId, 'SUPERUSER') || Controller.get().userMgr().hasOrgRole(orgId, 'VIEWER'))) { return false }
    return AppHelper.isSettingEnabled(orgId, 'CRM_RESTRICT_VIEW_ASSIGNED_ACCOUNTS')
  }
  static isPaymentTransactionEnabled(orgId) {
    return (AppHelper.isSettingEnabled(orgId, 'PAYMENT_LEDGER_CARD') || AppHelper.isSettingEnabled(orgId, 'PAYMENT_CONFIRMATION'))
  }
  static isClickToCallEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'CLICK_TO_CALL')
  }
  static isClickToWhatsAppEnabled(orgId) {
    return false
  }
  static isClickToWhatsAppAppEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'CLICK_TO_WHATSAPP_APP')
  }
  static isClickToZoomPhoneEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'CLICK_TO_ZOOM_PHONE')
  }
  static isStaffLoadEnabled(orgId) {
    return true
  }
  static isStaffActivityTrackingEnabled(orgId) {
    return true
  }
  static isStaffActivityInteractionFilterEnabled(orgId) {
    return true
  }
  static isViewerEnhanced(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'VIEWER_ENHANCED')
  }
  static isEntityInPlaceDrillDown(orgId) {
    return true
  }
  static isCRMUniboxEnabled(orgId) {
    return true
  }
  static isWAInteractionsViewEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'WHATSAPP_MENU')
  }
  static isWABroadcastsEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'WHATSAPP_MENU')
  }
  static isWAInteractionsViewPollingEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'WHATSAPP_MENU')
  }
  static isBulkProspectCsvEnabled(orgId) {
    return true
  }
  static isCrmDashboardCustomersCardEnabled(orgId) {
    return false
  }
  static isCompactStatsCardsMobileEnabled(orgId) {
    return true
  }
  static isCrmContactEditUtmCampaignEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'CRM_CONTACT_EDIT_UTM_CAMPAIGN')
  }
  static isCrmContactDrillDownButtonEnabled(orgId) {
    return !Helper.isMobileView()
  }
  static isCrmContactClickableEnabled(orgId) {
    return Helper.isMobileView()
  }
  static isCrmAccountTrendsMobileEnabled(orgId) {
    return Helper.isMobileView()
  }
  static isCrmAccountDrillDownButtonEnabled(orgId) {
    return !Helper.isMobileView()
  }
  static isCrmAccountClickableEnabled(orgId) {
    return Helper.isMobileView()
  }
  static isAdsExportEnabled(orgId) {
    return !Helper.isMobileView()
  }
  static isCrmDashboardUtmCampaignsChartEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'CRM_DASHBOARD_UTM_CAMPAIGNS_CHART')
  }
  static isCrmDashboardUtmContentsChartEnabled(orgId) {
    return AppHelper.isSettingEnabled(orgId, 'CRM_DASHBOARD_UTM_CONTENTS_CHART')
  }
  static getUniboxSortKey(orgId) {
    return AppHelper.getSetting(orgId, 'CRM_UNIBOX_SORT_KEY')
  }

  // Keep in sync with BE CrmTabHelper.getCrmContactCustomTabs / CRM_CONTACT_CUSTOM_TABS_NEW_DEFAULT
  static CRM_CONTACT_CUSTOM_TABS_NEW_DEFAULT =
    'label:All | label:New;filter:state=NEW;_sortKey:createdTs | label:Active;_sortKey:activeIntSentTs;active:true | label:Followups;filter:followupDatetime=due;_sortKey:followupDatetime'

  // Resolves CRM contact custom tabs. CRM_CONTACT_CUSTOM_TABS takes precedence when set;
  // otherwise CRM_CONTACT_TAB_MODE selects blank (LEGACY) or the NEW default tabs
  // (unset mode uses CDPSettingsConfig defaultValue, currently NEW).
  static getCrmContactCustomTabs(orgId) {
    const rawCustomTabs = AppHelper.getSetting(orgId, 'CRM_CONTACT_CUSTOM_TABS')
    const tabsSetting = (rawCustomTabs && String(rawCustomTabs).trim())
      ? rawCustomTabs
      : AppHelper.getSetting(orgId, 'CRM_CONTACT_TAB_MODE') === 'NEW'
        ? AppHelper.CRM_CONTACT_CUSTOM_TABS_NEW_DEFAULT
        : ''
    return Controller.get().cdpHelper().parseCDPArrayOfObjectsString(tabsSetting).filter(tab => !!tab.label)
  }

  static findOutFieldsToEnableCC(fieldDef) {
    const btnFields = []
    let navLinkPresent = false
    for(const f of fieldDef.steps[0].fields) {
      if(f.groupName === 'button1-label' || f.groupName === 'button2-label') {
        btnFields.push(f.key)
      }
      if(f.key === 'navLink') {
        navLinkPresent = true
      }
    }
    if(btnFields.length === 0 && navLinkPresent) return ['navLink']
    return btnFields
  }

  static findOutButtonFieldsToHide(fieldDef) {
    const btnFields = []
    let button1navLink = false
    let button1present = false
    for(const f of fieldDef.steps[0].fields) {
      if(f.groupName && f.groupName.startsWith('button')) {
        if(f.groupName === 'button1-label' || f.groupName === 'button2-label') {
          if(f.groupName === 'button1-navLink') button1navLink = true
          if(f.groupName === 'button1-label') button1present = true
          continue
        }
        btnFields.push(f.key)
      }
    }
    if(!button1navLink && button1present) {
      btnFields.push('navLink')
    }
    return btnFields
  }

  static acceptGifForImageFormField (fields) {
    for (let index = 0; index < fields.length; index++) {
      const field = fields[index]
      if(field.imageUpload === true && field.uploadAccept) {
        if(field.uploadAccept) {
          field.uploadAccept = field.uploadAccept + ', image/gif'
        } else {
          field.uploadAccept = 'image/png, image/jpeg, image/svg+xml, image/gif'
        }
      }
    }
  }

  static modifyFormFields(fields, keystoAssignAttributes = [],attributesToAssign = {}) {
    let itr = 0
    for (const field of fields) {
      if(keystoAssignAttributes.includes(field.key)) {
        Object.entries(attributesToAssign).forEach(([attr,value])=>{
          if(attr === 'placement') {
            field.placement = itr % 2 === 0 ? 'left' : 'right'
            itr += 1
            return
          }
          field[attr] = value
        })
      }
    }
  }

  static isNativeMobileApp() {
    return window && window.ReactNativeWebView && navigator && navigator.userAgent && navigator.userAgent.startsWith('Azslixta')
  }

  static postMessageToNativeApp(data) {
    if (data && AppHelper.isNativeMobileApp()) {
      window.ReactNativeWebView.postMessage(JSON.stringify(data))
    }
  }

  static parseOrgUnitId(orgUnitId) {
    const orgIdParts = (orgUnitId || '').split('-')
    const subOrgId = orgIdParts.length === 2 ? orgUnitId : ''
    const orgId = orgIdParts.length > 0 ? orgIdParts[0] : ''
    return {orgId, subOrgId}
  }
}
